var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRechargeManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 13.68a3.36 3.36 0 113.173-4.464M10.32 10.32H9.2V9.2",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64 18.16H4.72a1.12 1.12 0 01-1.12-1.12V4.72c0-.619.501-1.12 1.12-1.12h7.936c.297 0 .582.118.792.329l2.144 2.143c.21.21.328.495.328.792V8.64M17.6 14.8h2.8v-3.36M20.26 14.8a4.48 4.48 0 10-.838 3.915",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRechargeManagement;